"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const VerifyingIcon = ({ className }) => (react_1.default.createElement("svg", { className: className, width: "38", height: "38", xmlns: "http://www.w3.org/2000/svg", stroke: "#fff" },
    react_1.default.createElement("g", { transform: "translate(1 1)", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
        react_1.default.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
        react_1.default.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18" },
            react_1.default.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "1s", repeatCount: "indefinite" })))));
exports.default = VerifyingIcon;
//# sourceMappingURL=VerifyingIcon.js.map